/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { createContext, useEffect, useState } from "react";

export const traumaInformedContext = createContext([]);

export default function TraumaInformedContext({ children }) {
  const [traumaInformedData, settraumaInformedData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getTraumaInformedData = async () => {
    try {
      const result = await axios.get(
        `https://api.alachuacounty.us/truth-rec-backend/api/getTraumaInformedResources`
      );
      return result;
    } catch (error) {
      console.log({ error });
      setLoading(false);
      return [];
    }
  };

  const initialLoad = async () => {
    const result = await getTraumaInformedData();

    settraumaInformedData(result.data);
    setLoading(true);
  /*   console.log("Trauma Informed Data in context load:: ");
    console.log(result.data); */
  };

  useEffect(() => {
    initialLoad();
  }, []);

  return (
    <traumaInformedContext.Provider value={{ traumaInformedData, loading }}>
      {children}
    </traumaInformedContext.Provider>
  );
}
